/**
 * Configuration utilities for React app
 */

// API Gateway URL - can be overridden by environment variables
export const API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL || 'https://localhost:3000';

export default {
  API_GATEWAY_URL,
};

